import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ee0b1d9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title qrcode-title" }, "邀请二维码", -1))
const _hoisted_3 = { class: "qrcode-item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title my-invite-code" }, "我的邀请码", -1))
const _hoisted_5 = { class: "code-item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon icon-download" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "保存相册", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon icon-wechat" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "微信", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon icon-moments" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "朋友圈", -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]

import { Overlay } from 'vant'
import { useStore } from 'vuex'
import { generateWechatScheme } from '@/apis/public'
import { resizeInit } from '@/compositions/useWindowResize'
import { useOverlayCommonInfo } from '@/compositions/common'
import appHost, { isApp, isAndrod, isIos } from '@/utils/app'
import { useCommonShare } from '@/compositions/activity/index'
import { clearToast, getImageUrlBase64Data, showToastFail, showToastLoading } from '@/utils/tools'
import { withDefaults, onMounted, ref, watch, onUnmounted } from 'vue'
import Qrcode from '@chenfengyuan/vue-qrcode'
import DownloadMainWrap from './download-main-wrap.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'share-content',
  props: {
    show: { type: Boolean, default: false },
    qrcodeUrl: null,
    code: { default: '' }
  },
  emits: ['update:show'],
  setup(__props: any, { emit: emits }) {

const props = __props as { show: boolean, qrcodeUrl: string, code: string };


const vueStore = useStore()
const { setMiniProgramShareInfo, getShareUrlInfo, getShareBaseInfo } = useCommonShare()
const { overlayHeightValue } = useOverlayCommonInfo()
const shareWxImageUrl =
  'https://office.static.xag.cn/upload-file/umtsj46ae6868ea9c/20260212/test_output-116c33cd-3e59-471a-963f-c029a58a2ef5.jpg'

const qrcodeKey = ref(String(Math.random()))
const startDownload = ref(false)
const qrcodeOption = ref({
  width: 0,
  height: 0,
  margin: 0,
})

function overlayClick() {
  emits('update:show', false)
}

// 根据屏幕宽度自适应大小
function adjustQrcodeScreenValue() {
  const winWidth = window.innerWidth
  const value = (winWidth / 640) * 168
  if (qrcodeOption.value.width === value) {
    return
  }
  qrcodeOption.value = {
    ...qrcodeOption.value,
    width: value,
    height: value,
    margin: 0,
  }
  qrcodeKey.value = String(Math.random())
}
watch(
  () => props.show,
  () => {
    if (props.show) {
      adjustQrcodeScreenValue()
    }
  }
)

// 保存到相册
function downloadImageHandle() {
  showToastLoading()
  startDownload.value = true
}
// 获取小程序url
async function getMiniporgramUrlSchmera() {
  const miniPath = '/pages/webView'
  const query = `url=${encodeURIComponent(
    getShareUrlInfo({ code: vueStore?.state?.OldBringsNew?.inviteCode || '' }).inviteNewUserUrl
  )}`
  const env_version = process.env.VUE_APP_MINIPROGRAM_VERSION

  try {
    const data = await generateWechatScheme({
      jump_wxa: {
        env_version,
        path: miniPath,
        query,
      },
    })
    return data?.openlink
  } catch (error) {
    console.log('error', error)
    showToastFail('分享失败2' + error)
    return Promise.reject(error)
  }
}
// 分享到微信
async function shareToWechat() {
  showToastLoading()
  try {
    const iconData = await getImageUrlBase64Data(shareWxImageUrl)
    const link = await getMiniporgramUrlSchmera()
    const { mainTitle, secTitle } = getShareBaseInfo()
    const shareUrl = getShareUrlInfo({ urlSchmera: link }).appMiddleWrapUrl
    if (isAndrod) {
      await appHost.shareToWeChat({
        iconStr: iconData.unHeaderData,
        title: mainTitle,
        description: secTitle,
        shareUrl,
      })
    } else if (isIos) {
      await appHost.shareAction({
        title: mainTitle,
        desc: secTitle,
        image: iconData.unHeaderData,
        url: shareUrl,
        type: 0, // 0表示分享到微信
      })
    }
  } catch (error) {
    console.log('error', error)
  }
  clearToast()
}

// 分享到朋友圈
async function shareToMoments() {
  showToastLoading()
  try {
    const iconData = await getImageUrlBase64Data(shareWxImageUrl)
    const link = await getMiniporgramUrlSchmera()
    const { secTitle } = getShareBaseInfo()
    const shareUrl = getShareUrlInfo({ urlSchmera: link }).appMiddleWrapUrl
    if (isAndrod) {
      await appHost.shareToMoments({
        iconStr: iconData.unHeaderData,
        title: secTitle,
        description: secTitle,
        shareUrl,
      })
    } else if (isIos) {
      await appHost.shareAction({
        title: secTitle,
        desc: secTitle,
        image: iconData.unHeaderData,
        url: shareUrl,
        type: 1, // 1表示分享到朋友圈
      })
    }
  } catch (error) {
    console.log('error', error)
  }
  clearToast()
}

function handleDownloadComplete() {
  startDownload.value = false
  // clearToast()
}

resizeInit(adjustQrcodeScreenValue)
onMounted(() => {
  setMiniProgramShareInfo('new')
})
onUnmounted(() => {
  setMiniProgramShareInfo('')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Overlay), {
      show: props.show,
      onClick: overlayClick,
      class: "em-container overlay-item",
      style: _normalizeStyle({ height: _unref(overlayHeightValue) })
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "qrcode-wrap",
            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("i", {
              class: "icon-close",
              onClick: overlayClick
            }),
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              (props.qrcodeUrl)
                ? (_openBlock(), _createBlock(_unref(Qrcode), {
                    key: qrcodeKey.value,
                    value: props.qrcodeUrl,
                    options: qrcodeOption.value
                  }, null, 8, ["value", "options"]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, _toDisplayString(props.code), 1)
          ]),
          _createElementVNode("div", {
            class: "footer-item",
            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", null, [
              _createElementVNode("div", {
                class: "em-container",
                onClick: downloadImageHandle
              }, _hoisted_8),
              (_unref(isApp))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", {
                      class: "em-container",
                      onClick: shareToWechat
                    }, _hoisted_11),
                    _createElementVNode("div", {
                      class: "em-container",
                      onClick: shareToMoments
                    }, _hoisted_14)
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show", "style"]),
    _createVNode(DownloadMainWrap, {
      qrcodeUrl: props.qrcodeUrl,
      startDownload: startDownload.value,
      code: props.code,
      onDownloadComplete: handleDownloadComplete
    }, null, 8, ["qrcodeUrl", "startDownload", "code"])
  ], 64))
}
}

})